import React, { PureComponent } from 'react'
import { Button, Form, Input, Icon, message } from 'antd'
import { userLogin } from '_src/api/api'
import './login.less'
import Background from '_src/assets/bgImg.jpg'

class Login extends PureComponent {
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const hide = message.loading('登录中...', 0)
        userLogin(values)
          .then(async res => {
            hide()
            message.success('登录成功', 2)
            localStorage.setItem('access_info', JSON.stringify({
              ...res.data,
            }))
           
            // const infor = await getMerchant()
            // const { data: {idCardReverse, idCardObverse} } = infor
            // // const { idCardObverse, idCardReverse } = category
            // if (!idCardObverse&&!idCardReverse) {
            //   this.props.history.replace('/setMerchant')
            // }
            // else {
            let q = this.props.location.search || ''
            q = q ? decodeURIComponent(q.substring(q.indexOf('q=') + 2)) : '/home'
            this.props.history.replace(q)
            this.setState({
              data: res.data
            })
            // }
          })
          .catch(error => {
            hide()
          })
      }
    })
  }
  getname = (e) => {
    debugger
    const { data } = this.state
    let username = e.target.value
    if (username === data.name) {
      this.setState({
        username: username
      })
    }
    else {
      message.error('账户名不存在', 0)
    }
  }
  getPassword = (e) => {
    let num = e.target.value
    this.setState({
      password: num
    })
  }
    
  render () {
    const { getFieldDecorator } = this.props.form
    return (
      <div className='login-page' style={{backgroundImage: `url(${Background})`}}>
        <div className='logo-box'>
          <img alt="慧途科技" className='logo-img' src='/assets/logo.png' />
          <div className='logo-title'>欢迎登录慧途科技系统管理平台</div>

          <Form onSubmit={this.handleSubmit} className="login-form">
            <Form.Item>
              {getFieldDecorator('username', {
                rules: [{ required: true, message: '请输入管理员账号!' }],
              })(
                <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  placeholder="请输入管理员账号"
                  onChange={this.getName}
                  allowClear
                  className='form-input'
                />
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: '请输入管理员密码!' }],
              })(
                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                  type="password" placeholder="请输入管理员密码"
                  onChange={this.getPassword}
                  allowClear
                  className='form-input'
                />
              )}
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" className="login-form-button">
                登录
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    )
  }
}

export default Form.create({ name: 'horizontal_login' })(Login)
